import {
  GET_MENU,
  GET_HALLOFFAMES,
  CREATE_HALLOFFAMER,
  DELETE_HALLOFFAMER,
  LIKE_HALLOFFAMER,
  APPROVE_HALLOFFAMER,
  GET_AVALIABLE_JIRA_SPRINT,
  CREATE_SPRINT,
  GET_PROJECT,
  GET_PROJECT_SUMMARY,
  GET_PROJECT_STATUS,
  GET_ORGANIZATION_ORGANIZATIONS,
  PROJECT_BASICINFO,
  UPDATE_PROJECT_BASICINFO,
  PROJECT_ALL,
  UPDATE_SCRUM_TEAMS,
  PROJECT_MANAGERS,
  GET_DEVMETRICS,
  CREATE_DELETE_DEVMETRIC,
  UPDATE_DEVMETRIC,
  GET_QA_MANAGEMENT_SUMMARY,
  GET_CADENCE_CHART_SUMMARY,
  UpdateStoryCycleTimeThreshold,
  UpdateSprintNotes,
  USER_MARKET_CODE_LIST,
  BILLING_INVOICE,
  BILLING_INVOICE_BY_ID,
  BILLING_ANALYSIS_KPIS,
  BILLING_ANALYSIS_COST_DISTRIBUTION,
  BILLING_ANALYSIS_MONTHLY_COST_DISTRIBUTION,
  BILLING_ANALYSIS_MONTHLY_INVOICE_DETAILS,
  BILLING_ANALYSIS_SP_AND_COST,
  BILLING_ANALYSIS_SP_CATEGORY_COMPOSITION,
  BILLING_ANALYSIS_MONTHLY_INVOICE_OVERVIEW,
  BILLING_ANALYSIS_MONTHLY_INVOICE_ACCOUNTS,
  BILLING_ANALYSIS_MARKET_CODE_GROUPS,
  GET_QA_CHART_SETTING,
  GET_RULE_VALUE_TARGET,
  BASE_QA_CHART_SETTING,
  GET_DEVCHARTS,
  GET_SCRUM_TEAMS,
  GET_USER_INFOS,
  GET_USER_INFOS_MANANGE,
  UPDATE_USER_LOGOUT,
  GET_MESSAGES,
  UPDATE_MESSAGES,
  GET_UNREAD_MESSAGE_COUNT,
  GET_MESSAGE_COUNTS,
  USER_INFO,
  USER_ALLOCATION,
  GET_USER_ROLES,
  UPDATE_USER_ROLE_ADD,
  UPDATE_USER_ROLE_DELETE,
  GET_ROSTER_OVERVIEW,
  GET_PROJECT_ROLES,
  GET_RULE_HISTORY,
  UPDATE_RULE_HISTORY,
  UPDATE_PROJECT_HEALTH,
  UPDATE_USERINFO_AVATAR,
  GET_ALL_DICTTYPE,
  GET_USER_PROJECTS_CURRENT_SPRINT,
  MENU_QUICK_ACTION,
  DELETE_MENU_QUICK_ACTIONS,
  GET_USER_PERMISSIONS,
  GET_PROJECT_HEALTH_BY_PROJECT_STATUS,
  GET_USER_TYPE_ALLOCATION,
  GET_ALL_SCRUM_TEAMS,
  GET_ALL_CURRENT_RELEASE,
  GET_ALL_PROJECT_RISKDAYS,
  GET_ALL_PROJECT_MILESTONE,
  GET_ALL_MILESTONE_RISKDAYS,
  GET_ALL_SPRINT_RISKDAYS,
  GET_LATEST_ASSESSMENT_VERSION,
  SYNC_USER_FROM_KEYCLOAK,
  GET_SPRINT_ASSESSMENT_SETTINGS,
  UPDATE_SPRINT_ASSESSMENT_SETTINGS,
  GET_SPRINT_ASSESSMENT,
  GET_SPRINT_ASSESSMENT_DETAILS,
  GET_ASSESSMENT_MAX_VERSION_BY_PROJECT,
  MAX_VERSION_USED,
  GET_RETRO_ASSESSMENT_STATUS,
  GET_SPRINT_ASSESSMENT_ANALYSIS,
  SPRINT_ASSESSMENT_ANALYSIS_SENTIMENT,
  GET_COMMENT_DETAILS,
  GET_SENTIMENT_DISTRIBUTIONS,
  ASSESSMENT_TRENDS_OVER_TIME,
  GET_MENU_THEME_LATEST,
  SAVE_MENU_THEME,
  GET_MENU_FULL,
  CLONE_PERMISSIONS_BATCH,
  USER_ROLES_DETAIL,
  SCRUMTEAMMEMBER,
  UPDATESCRUMTEAMMEMBER,
  GET_ALL_PROJECT,
  USER_ALLOCATION_MANY,
  INCIDENT_MATRIX_STATS,
  INCIDENT_MATRIX_CHART,
  INCIDENT_OVERVIEW_PERFORMERS,
  INCIDENT_OVERVIEW_CATEGORIES,
  GET_STATUS_MONITOR,
  GET_ACTIVE_SPRINTS,
  GET_EFFICIENCY_RANKING,
  GET_DELIVERY_STATUS,
  GET_TEAM_COMPOSITION,
  PROJECT_HOME_PROJECT_SUMMARY,
  GET_QA_KANBAN_BUG_BACKLOG,
  GET_QA_KANBAN_QA_CREATED,
  GET_QA_KANBAN_INCIDENT_PRODUCT,
  GET_QA_KANBAN_AUTOMATION_STATUS,
  BILLING_INVOICE_BILL_TOS,
  BILLING_INVOICE_UPLOAD,
  BILLING_INVOICE_UPLOAD_SUBMIT,
  BILLING_INVOICE_IMPORT_PREVIEW,
  BILLING_INVOICE_SAVE_PREVIEW,
  BILLING_INVOICE_GROUP,
  GET_SUB_APPLICATION_LIST,
  GET_SUB_APP_ROLE_ASSIGN,
  GET_GROUPS,
  GET_SUB_APP_ROLE_ASSIGN_ASSIGNED_ROLES,
  POST_SUB_APP_ROLE_ASSIGN,
  GET_GROUP_ROLE_ASSIGN_ASSIGNED_ROLES,
  GET_GROUP_ASSIGNED_ROLES_BY_USER_ID,
  GET_MY_ACCESSIBLE_SUB_APPLICATIONS,
  POST_GROUP_ROLE_ASSIGN,
  GET_PLATFORM_DATA_HUB_PERMISSION,
  CREATE_SUB_APPLICATION,
  UPDATE_SUB_APPLICATION,
  ACTIVE_SUB_APPLICATION,
  GET_SUB_APPLICATION_DETAIL,
  GET_SUB_APPLICATION_DEFAULT
} from './Api';
import request from './axiosConfig';
import { objectToQueryParams } from './utils';

/**  welcome page  */

const getUserProjectsCurrentSprint = (userId, notShowSprint = false) =>
  request.get(GET_USER_PROJECTS_CURRENT_SPRINT + `?userId=${userId}&notShowSprint=${notShowSprint}`);
const createMenuQuickAction = (params) => request.post(MENU_QUICK_ACTION, params);
const deleteMenuQuickActions = (params) => request.put(DELETE_MENU_QUICK_ACTIONS, params);
const getMenuQuickActions = (userId) => request.get(MENU_QUICK_ACTION + `?UserId=${userId}`);
const getMenuThemeLatest = () => request.get(GET_MENU_THEME_LATEST);
const saveMenuTheme = (body) => request.post(SAVE_MENU_THEME, body);
export const getMenuFull = () => request.get(GET_MENU_FULL);

const getMenus = () => request.get(GET_MENU);
const getHallOfFames = () => request.get(GET_HALLOFFAMES);
const getMessages = (params) => request.get(`${GET_MESSAGES}${toQueryString(params)}`);
const updateMessages = (messages) => request.put(UPDATE_MESSAGES, messages);
const getUnreadMessageCount = (userId) => request.get(`${GET_UNREAD_MESSAGE_COUNT}${encodeURIComponent(userId)}`);
const getMessageCounts = (userId) => request.get(`${GET_MESSAGE_COUNTS}/${encodeURIComponent(userId)}`);
const createHallOfFamer = (params) => request.post(CREATE_HALLOFFAMER, params);
const deleteHallOfFamer = (id) => request.delete(`${DELETE_HALLOFFAMER}${id}`);
const likeHallOfFamer = (params) => request.post(LIKE_HALLOFFAMER, params);
const approvalHallOfFamer = (id) => request.get(`${APPROVE_HALLOFFAMER}${id}`);

const toQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          searchParams.append(key, item);
        }
      });
    } else if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};

const getBillingBillTos = () => request.get(BILLING_INVOICE_BILL_TOS);
const getBillingInvoices = (params) => request.get(`${BILLING_INVOICE}${toQueryString(params)}`);
const getBillingInvoice = (params) => request.get(`${BILLING_INVOICE_GROUP}${toQueryString(params)}`);
const deleteBillingInvoice = (params) => request.delete(`${BILLING_INVOICE_GROUP}${toQueryString(params)}`);
const uploadBillingInvoice = (formData) => request.post(BILLING_INVOICE_UPLOAD, formData);
const uploadSubmitBillingInvoice = (body) => request.post(BILLING_INVOICE_UPLOAD_SUBMIT, body);
const getBillingInvoiceImportPreview = (params) =>
  request.get(`${BILLING_INVOICE_IMPORT_PREVIEW}${toQueryString(params)}`);
const saveBillingInvoicePreview = (body) => request.post(BILLING_INVOICE_SAVE_PREVIEW, body);

const getRequest = (projectId, url) =>
  request.get(`${url}?__project=${projectId}`, {
    headers: { __project: projectId }
  });

const updateRequest = (projectId, params, url) =>
  request.put(`${url}?__project=${projectId}`, params, {
    headers: { __project: projectId }
  });

/* sprint grid Requests */
const getAvailableSprint = (params) =>
  request.get(`${GET_AVALIABLE_JIRA_SPRINT}${objectToQueryParams(params)}`, {
    headers: { __project: params.__projectId }
  });

const createSprint = (projectId, params) => request.post(`${CREATE_SPRINT}?__project=${projectId}`, params);
const updateSprint = (projectId, params, sprintId = '') =>
  request.put(`${CREATE_SPRINT}${sprintId}?__project=${projectId}`, params);
const deleteSprint = (projectId, sprintId) => request.delete(`${CREATE_SPRINT}${sprintId}?__project=${projectId}`);

/* QA Chart Requests */
const getQaManagementSummary = (params) =>
  request.get(`${GET_QA_MANAGEMENT_SUMMARY}${objectToQueryParams(params)}`, {
    headers: { __project: params.ProjectId }
  });

const getProjectHomeStatusMonitor = (obj) => request.get(GET_STATUS_MONITOR + objectToQueryParams(obj));

const getProjectHomeActiveSprints = (obj) => request.get(GET_ACTIVE_SPRINTS + objectToQueryParams(obj));

const getProjectHomeEfficiencyRanking = (obj) => request.get(GET_EFFICIENCY_RANKING + objectToQueryParams(obj));

const getProjectHomeDeliveryStatus = (obj) => request.get(GET_DELIVERY_STATUS + objectToQueryParams(obj));

const getProjectHomeTeamComposition = (obj) => request.get(GET_TEAM_COMPOSITION + objectToQueryParams(obj));

const getProjectHomeProjectSummary = (obj) =>
  request.get(PROJECT_HOME_PROJECT_SUMMARY + objectToQueryParams(obj));

const getProjectHomeProjectSummaryById = (summaryId, obj = {}) =>
  request.get(`${PROJECT_HOME_PROJECT_SUMMARY}/${summaryId}${objectToQueryParams(obj)}`);

const addProjectHomeProjectSummary = (projectId, body) =>
  request.post(PROJECT_HOME_PROJECT_SUMMARY + objectToQueryParams({ __project: projectId }), body);

const updateProjectHomeProjectSummary = (projectId, summaryId, body) =>
  request.put(
    `${PROJECT_HOME_PROJECT_SUMMARY}/${summaryId}${objectToQueryParams({ __project: projectId })}`,
    body
  );

const deleteProjectHomeProjectSummary = (projectId, summaryId) =>
  request.delete(`${PROJECT_HOME_PROJECT_SUMMARY}/${summaryId}${objectToQueryParams({ __project: projectId })}`);

const getQaKanbanBugBacklog = (obj) => request.get(GET_QA_KANBAN_BUG_BACKLOG + objectToQueryParams(obj));

const getQaKanbanQaCreated = (obj) => request.get(GET_QA_KANBAN_QA_CREATED + objectToQueryParams(obj));

const getQaKanbanIncidentProduct = (obj) => request.get(GET_QA_KANBAN_INCIDENT_PRODUCT + objectToQueryParams(obj));

const getQaKanbanAutomationStatus = (obj) => request.get(GET_QA_KANBAN_AUTOMATION_STATUS + objectToQueryParams(obj));
/* Cadence Chart Requests */
const getCadenceChartSummary = (params) =>
  request.get(`${GET_CADENCE_CHART_SUMMARY}${objectToQueryParams(params)}`, {
    headers: { __project: params.ProjectId }
  });
/* AssemssmentSettings */
const getSprintAssemssmentSettings = (ProjectId) =>
  request.get(`${GET_SPRINT_ASSESSMENT_SETTINGS}`, {
    headers: { __project: ProjectId }
  });

const getVersionUsed = (ProjectId) =>
  request.get(`${MAX_VERSION_USED}`, {
    headers: { __project: ProjectId }
  });

const getLatestVersion = (ProjectId) =>
  request.get(`${GET_LATEST_ASSESSMENT_VERSION}`, {
    headers: { __project: ProjectId }
  });

/* Assemssment Analyse */
const getSprintAssemssmentAnalysis = (ProjectId, lastRetroNum, version) =>
  request.get(
    `${GET_SPRINT_ASSESSMENT_ANALYSIS}` + `?lastRetroNum=${lastRetroNum}&projectId=${ProjectId}&version=${version}`,
    {
      headers: { __project: ProjectId }
    }
  );

/* Assemssment Analyse Sentiment */
const getSprintAssemssmentAnalysisSentiment = (ProjectId, lastRetroNum, version) =>
  request.get(
    `${SPRINT_ASSESSMENT_ANALYSIS_SENTIMENT}` +
      `?lastRetroNum=${lastRetroNum}&projectId=${ProjectId}&version=${version}`,
    {
      headers: { __project: ProjectId }
    }
  );

/* Assemssment Trends OverTime */
const getAssessmentTrendsOverTime = (ProjectId, latestRetroCount, version) =>
  request.get(
    `${ASSESSMENT_TRENDS_OVER_TIME}` + `?LatestRetroCount=${latestRetroCount}&projectId=${ProjectId}&version=${version}`
  );

/* Retro assessment status */
const getRetroAssessmentStatus = (ProjectId, sprintId, retroBoardId) =>
  request.get(`${GET_RETRO_ASSESSMENT_STATUS}` + `?sprintId=${sprintId}&retroBoardId=${retroBoardId}`, {
    headers: { __project: ProjectId }
  });

const getAssessmentCommentDetails = (ProjectId, latestRetroCount, version) =>
  request.get(
    `${GET_COMMENT_DETAILS}` + `?latestRetroCount=${latestRetroCount}&ProjectId=${ProjectId}&version=${version}`,
    {
      headers: { __project: ProjectId }
    }
  );

const getSentimentDistributions = (ProjectId, latestRetroCount, version) =>
  request.get(
    `${GET_SENTIMENT_DISTRIBUTIONS}` +
      `?LatestRetroCount=${latestRetroCount}&ProjectId=${ProjectId}&version=${version}`,
    {
      headers: { __project: ProjectId }
    }
  );

const updateSprintAssemssmentSettings = (ProjectId, body) =>
  request.post(`${UPDATE_SPRINT_ASSESSMENT_SETTINGS}`, body, {
    headers: { __project: ProjectId }
  });

const updateCadenceChartAlterThresholdValue = (projectId, body) =>
  request.post(UpdateStoryCycleTimeThreshold + `?__project=${projectId}`, body);

const updateCadenceChartSprintNote = (projectId, body) =>
  request.post(UpdateSprintNotes + `?__project=${projectId}`, body);

const getUserMarketCodeList = () => request.get(`${USER_MARKET_CODE_LIST}`);

const getBillingInvoiceList = (params = {}) => request.get(`${BILLING_INVOICE}${objectToQueryParams(params)}`);

const getBillingInvoiceById = (id) => request.get(`${BILLING_INVOICE_BY_ID}${id}`);

// Billing-analysis endpoints accept `MarketCodes` as an array (repeated key:
// `?MarketCodes=410&MarketCodes=411`). The shared `objectToQueryParams`
// helper does not support array values, so build the query string locally.
const billingAnalysisQuery = (params = {}) => {
  const parts = [];
  Object.entries(params).forEach(([key, value]) => {
    if (value == null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v != null && v !== '') parts.push(`${key}=${encodeURIComponent(v)}`);
      });
    } else {
      parts.push(`${key}=${encodeURIComponent(value)}`);
    }
  });
  return parts.length ? `?${parts.join('&')}` : '';
};

const getBillingAnalysisKpis = (params = {}) => request.get(`${BILLING_ANALYSIS_KPIS}${billingAnalysisQuery(params)}`);

const getBillingAnalysisCostDistribution = (params = {}) =>
  request.get(`${BILLING_ANALYSIS_COST_DISTRIBUTION}${billingAnalysisQuery(params)}`);

const getBillingAnalysisMonthlyCostDistribution = (params = {}) =>
  request.get(`${BILLING_ANALYSIS_MONTHLY_COST_DISTRIBUTION}${billingAnalysisQuery(params)}`);

const getBillingAnalysisMonthlyInvoiceDetails = (params = {}) =>
  request.get(`${BILLING_ANALYSIS_MONTHLY_INVOICE_DETAILS}${billingAnalysisQuery(params)}`);

const getBillingAnalysisSpAndCost = (params = {}) =>
  request.get(`${BILLING_ANALYSIS_SP_AND_COST}${billingAnalysisQuery(params)}`);

const getBillingAnalysisSpCategoryComposition = (params = {}) =>
  request.get(`${BILLING_ANALYSIS_SP_CATEGORY_COMPOSITION}${billingAnalysisQuery(params)}`);

// `monthly-invoice-overview` requires `Month` (YYYY-MM) and accepts optional
// `MarketCodes` (repeated query key) to limit which markets appear in the
// bubble chart.
const getBillingAnalysisMonthlyInvoiceOverview = (params = {}) =>
  request.get(`${BILLING_ANALYSIS_MONTHLY_INVOICE_OVERVIEW}${billingAnalysisQuery(params)}`);

// `monthly-invoice-accounts` requires `Month` (YYYY-MM) and `MarketCode`
// (singular — one market per call).
const getBillingAnalysisMonthlyInvoiceAccounts = (params = {}) =>
  request.get(`${BILLING_ANALYSIS_MONTHLY_INVOICE_ACCOUNTS}${billingAnalysisQuery(params)}`);

const getBillingAnalysisMarketCodeGroups = () => request.get(BILLING_ANALYSIS_MARKET_CODE_GROUPS);

const getQaChartSetting = (projectId) => request.get(`${GET_QA_CHART_SETTING}?__project=${projectId}`);
const updateQaChartSetting = (params) => request.put(BASE_QA_CHART_SETTING, params);

const getRuleValue = (projectId, rule) => request.get(`${GET_RULE_VALUE_TARGET}?ProjectId=${projectId}&rule=${rule}`);

/* Project Home Requests */
const getProject = (projectId) =>
  request.get(GET_PROJECT + projectId, {
    headers: { __project: projectId }
  });
const getProjectSummary = (obj) => request.get(GET_PROJECT_SUMMARY + objectToQueryParams(obj));
const getProjectHealth = (projectId) => request.get(GET_PROJECT_STATUS + `?__project=${projectId}`);
const getOrganizations = (projectId) => request.get(`${GET_ORGANIZATION_ORGANIZATIONS}${projectId}`);
const updateProjectSummary = (projectId, summaryId, body) =>
  request.put(GET_PROJECT_SUMMARY + summaryId + `?__project=${projectId}`, body);
const addProjectSummary = (projectId, body) => request.post(GET_PROJECT_SUMMARY + `?__project=${projectId}`, body);
const deleteProjectSummary = (projectId, summaryId) =>
  request.delete(GET_PROJECT_SUMMARY + summaryId + `?__project=${projectId}`);

/* Project Home Requests */
const getProjectBasicInfo = (projectId) => getRequest(projectId, PROJECT_BASICINFO);
const getProjectAll = (currentSize, pageSize) =>
  request.get(PROJECT_ALL + `?currentPage=${currentSize}&pageSize=${pageSize}`);
const updateProjectBasicInfo = (projectId, params) => updateRequest(projectId, params, UPDATE_PROJECT_BASICINFO);
const getScrumTeams = (projectId) => getRequest(projectId, GET_SCRUM_TEAMS);
const updateCadence = (projectId, scrumTeamId, params) =>
  request.put(`${UPDATE_SCRUM_TEAMS}${scrumTeamId}`, params, {
    headers: { __project: projectId }
  });
const updateProjectManagers = (projectId, params) => updateRequest(projectId, params, PROJECT_MANAGERS);
const deleteProjectManagers = (projectId) => {
  return request.delete(`${PROJECT_MANAGERS}?__project=${projectId}`, {
    headers: { __project: projectId }
  });
};
const getRuleHistory = (projectId) => getRequest(projectId, GET_RULE_HISTORY);
const updateRuleHistory = (projectId, params) => updateRequest(projectId, params, UPDATE_RULE_HISTORY);
const updateProjectHealth = (projectId, projectHealthId, params) =>
  request.put(`${UPDATE_PROJECT_HEALTH}${projectHealthId}`, params, {
    headers: { __project: projectId }
  });

/* dev metrics section */
const getDevMetrics = (projectId, currentPage, pageSize) =>
  request.get(`${GET_DEVMETRICS}?__project=${projectId}&currentPage=${currentPage}&pageSize=${pageSize}`, {
    headers: { __project: projectId }
  });

const createDevMetrics = (projectId, params) =>
  request.post(`${CREATE_DELETE_DEVMETRIC}`, params, {
    headers: { __project: projectId }
  });
const updateDevMetrics = (projectId, params) => updateRequest(projectId, params, UPDATE_DEVMETRIC);
const deleteDevMetric = (projectId, id) =>
  request.delete(`${CREATE_DELETE_DEVMETRIC}${id}`, {
    headers: { __project: projectId }
  });

/* usermanagement section */
const getUserInfos = (params) =>
  request.get(params ? `${GET_USER_INFOS}${objectToQueryParams(params)}` : GET_USER_INFOS);
const getUserManagement = (params) =>
  request.get(params ? `${GET_USER_INFOS_MANANGE}${objectToQueryParams(params)}` : GET_USER_INFOS_MANANGE);
const getUserRoles = (params) =>
  request.get(params ? `${GET_USER_ROLES}${objectToQueryParams(params)}` : GET_USER_ROLES);

const getUserPermissions = (params) =>
  request.get(params ? `${GET_USER_PERMISSIONS}${objectToQueryParams(params)}` : GET_USER_PERMISSIONS);

const updateUserRoleAdd = (params) => request.post(`${UPDATE_USER_ROLE_ADD}`, params);

const updateUserRoleDelete = (params) => request.post(`${UPDATE_USER_ROLE_DELETE}`, params);

const getRosterOverView = () => request.get(GET_ROSTER_OVERVIEW);
const getProjectRoles = (params) =>
  request.get(params ? `${GET_PROJECT_ROLES}${objectToQueryParams(params)}` : GET_PROJECT_ROLES);

const createUserInfo = (params) => request.post(USER_INFO, params);
const updateUserInfo = (params) => request.put(USER_INFO, params);
const createUserAllocation = (params) => request.post(USER_ALLOCATION, params);
const updateUserAllocation = (params) => request.put(USER_ALLOCATION, params);
const updateUserAllocationBulk = (params) => request.put(USER_ALLOCATION_MANY, params);
const deleteUserAllocation = (id) => request.delete(USER_ALLOCATION + id);
const updateUserLogout = () => request.put(UPDATE_USER_LOGOUT);
const syncUserFromKeycloak = () => request.post(SYNC_USER_FROM_KEYCLOAK);

const createScrumTeamMember = (scrumTeamMember) => request.post(SCRUMTEAMMEMBER, scrumTeamMember);
const updateScrumTeamMember = (scrumTeamMember) =>
  request.put(UPDATESCRUMTEAMMEMBER + `${scrumTeamMember.id}`, scrumTeamMember);
const deleteScrumTeamMember = (id) => request.delete(UPDATESCRUMTEAMMEMBER + `${id}`);

/* dev charts section */
const getDevCharts = (params) =>
  request.get(`${GET_DEVCHARTS}${params.CategoryName}?${params.ProjectId}`, {
    headers: { __project: params.ProjectId }
  });

/* Header */
const getUserInfoAvatar = (uid) => request.get(`${USER_INFO}${uid}`);

const createUserInfoAvatar = (userInfoAvatar) => request.post(USER_INFO, userInfoAvatar);

const updateUserInfoAvatar = (userInfoAvatar) => request.put(UPDATE_USERINFO_AVATAR, userInfoAvatar);

const getAllDictType = () => request.get(GET_ALL_DICTTYPE);

/* Executive summary */
const getProjectHealthByProjectStatus = (params) =>
  request.get(`${GET_PROJECT_HEALTH_BY_PROJECT_STATUS}${objectToQueryParams(params)}`);
const getAllUserTypeAllocation = () => request.get(GET_USER_TYPE_ALLOCATION);
const getAllScrumTeams = () => request.get(GET_ALL_SCRUM_TEAMS);
const getAllCurrentRelease = () => request.get(GET_ALL_CURRENT_RELEASE);
const getAllProjectRiskDays = () => request.get(GET_ALL_PROJECT_RISKDAYS);
const getAllProjectMilestone = () => request.get(GET_ALL_PROJECT_MILESTONE);
const getAllMilestoneRiskDays = () => request.get(GET_ALL_MILESTONE_RISKDAYS);
const getAllSprintRiskDays = () => request.get(GET_ALL_SPRINT_RISKDAYS);
const getAllProject = () => request.get(GET_ALL_PROJECT);

const getSprintAssessment = (params) =>
  request.get(`${GET_SPRINT_ASSESSMENT}${objectToQueryParams(params)}`, {
    headers: { __project: params.ProjectId }
  });

const getSprintAssessmentDetails = (params) =>
  request.get(`${GET_SPRINT_ASSESSMENT_DETAILS}${objectToQueryParams(params)}`, {
    headers: { __project: params.ProjectId }
  });

const getAssessmentMaxVersionByProject = (projectId) =>
  request.get(`${GET_ASSESSMENT_MAX_VERSION_BY_PROJECT}/${projectId}`, {
    headers: { __project: projectId }
  });

const clonePermissionsBatch = (params) => request.post(CLONE_PERMISSIONS_BATCH, params);
const getUserRolesDetail = (paramsOrUserId) => {
  const userId = typeof paramsOrUserId === 'string' ? paramsOrUserId : paramsOrUserId?.userId;
  const otherParams = typeof paramsOrUserId === 'object' && paramsOrUserId ? { ...paramsOrUserId } : undefined;
  if (otherParams && 'userId' in otherParams) delete otherParams.userId;
  const baseUrl = userId ? `${USER_ROLES_DETAIL}?userId=${userId}` : USER_ROLES_DETAIL;
  const url =
    otherParams && Object.keys(otherParams).length ? `${baseUrl}${objectToQueryParams(otherParams)}` : baseUrl;
  return request.get(url);
};

/* Incident Analysis */
const getIncidentMatrixStats = (granularity) => {
  return request.get(`${INCIDENT_MATRIX_STATS}?granularity=${granularity}`);
};

const getIncidentMatrixChart = (granularity) => {
  return request.get(`${INCIDENT_MATRIX_CHART}?granularity=${granularity}`);
};

const getIncidentOverviewPerformers = (period, paginationParams = {}) => {
  const query = objectToQueryParams({
    days: period,
    ...paginationParams
  });
  return request.get(`${INCIDENT_OVERVIEW_PERFORMERS}${query}`);
};

const getIncidentOverviewCategories = (period) => {
  return request.get(`${INCIDENT_OVERVIEW_CATEGORIES}?days=${encodeURIComponent(period)}`);
};

const getSubApplicationList = (params = {}) => request.get(`${GET_SUB_APPLICATION_LIST}${objectToQueryParams(params)}`);

const getSubAppRoleAssign = (params = {}) => request.get(`${GET_SUB_APP_ROLE_ASSIGN}${objectToQueryParams(params)}`);

const getGroups = (params = {}) => request.get(`${GET_GROUPS}${objectToQueryParams(params)}`);

const getSubAppRoleAssignAssignedRoles = (userId) =>
  request.get(`${GET_SUB_APP_ROLE_ASSIGN_ASSIGNED_ROLES}/${encodeURIComponent(userId)}`);

const postSubAppRoleAssign = (body) => request.post(POST_SUB_APP_ROLE_ASSIGN, body);

const getGroupAssignedRoles = (groupId) =>
  request.get(`${GET_GROUP_ROLE_ASSIGN_ASSIGNED_ROLES}/${encodeURIComponent(groupId)}`);

const getGroupAssignedRolesByUserId = (userId) =>
  request.get(`${GET_GROUP_ASSIGNED_ROLES_BY_USER_ID}/${encodeURIComponent(userId)}`);

const getMyAccessibleSubApplications = (params = {}) =>
  request.get(`${GET_MY_ACCESSIBLE_SUB_APPLICATIONS}${objectToQueryParams(params)}`);

const postGroupRoleAssign = (body) => request.post(POST_GROUP_ROLE_ASSIGN, body);

const getPlatformDataHubPermission = () => request.get(GET_PLATFORM_DATA_HUB_PERMISSION);

const createSubApplication = (params) => request.post(CREATE_SUB_APPLICATION, params);

const updateSubApplication = (id, params) => request.put(`${UPDATE_SUB_APPLICATION}${encodeURIComponent(id)}`, params);

const activeSubApplication = (id) => request.put(`${ACTIVE_SUB_APPLICATION}${encodeURIComponent(id)}/active`);

const getSubApplication = (id) => request.get(`${GET_SUB_APPLICATION_DETAIL}${encodeURIComponent(id)}`);

const getSubApplicationDefault = () => request.get(GET_SUB_APPLICATION_DEFAULT);

export {
  createMenuQuickAction,
  deleteMenuQuickActions,
  getMenuQuickActions,
  getMenuThemeLatest,
  saveMenuTheme,
  getUserProjectsCurrentSprint,
  getMenus,
  getHallOfFames,
  getMessages,
  updateMessages,
  getUnreadMessageCount,
  getMessageCounts,
  createHallOfFamer,
  deleteHallOfFamer,
  getAvailableSprint,
  createSprint,
  updateSprint,
  deleteSprint,
  getUserInfos,
  updateUserLogout,
  getUserRoles,
  getUserPermissions,
  updateUserRoleAdd,
  updateUserRoleDelete,
  getProjectRoles,
  createUserInfo,
  updateUserInfo,
  createUserAllocation,
  updateUserAllocation,
  deleteUserAllocation,
  likeHallOfFamer,
  approvalHallOfFamer,
  getProject,
  getProjectSummary,
  getProjectHealth,
  getOrganizations,
  getProjectBasicInfo,
  getProjectAll,
  updateProjectBasicInfo,
  updateProjectManagers,
  deleteProjectManagers,
  updateCadence,
  getDevMetrics,
  createDevMetrics,
  updateDevMetrics,
  deleteDevMetric,
  getQaManagementSummary,
  getProjectHomeStatusMonitor,
  getProjectHomeActiveSprints,
  getProjectHomeEfficiencyRanking,
  getProjectHomeDeliveryStatus,
  getProjectHomeTeamComposition,
  getProjectHomeProjectSummary,
  getProjectHomeProjectSummaryById,
  addProjectHomeProjectSummary,
  updateProjectHomeProjectSummary,
  deleteProjectHomeProjectSummary,
  getQaKanbanBugBacklog,
  getQaKanbanQaCreated,
  getQaKanbanIncidentProduct,
  getQaKanbanAutomationStatus,
  getCadenceChartSummary,
  updateCadenceChartAlterThresholdValue,
  updateCadenceChartSprintNote,
  getUserMarketCodeList,
  getBillingInvoiceList,
  getBillingInvoiceById,
  getBillingAnalysisKpis,
  getBillingAnalysisCostDistribution,
  getBillingAnalysisMonthlyCostDistribution,
  getBillingAnalysisMonthlyInvoiceDetails,
  getBillingAnalysisSpAndCost,
  getBillingAnalysisSpCategoryComposition,
  getBillingAnalysisMonthlyInvoiceOverview,
  getBillingAnalysisMonthlyInvoiceAccounts,
  getBillingAnalysisMarketCodeGroups,
  getQaChartSetting,
  updateQaChartSetting,
  getRuleValue,
  getScrumTeams,
  addProjectSummary,
  deleteProjectSummary,
  updateProjectSummary,
  getUserInfoAvatar,
  createUserInfoAvatar,
  updateUserInfoAvatar,
  getDevCharts,
  getRuleHistory,
  updateRuleHistory,
  updateProjectHealth,
  getAllDictType,
  getProjectHealthByProjectStatus,
  getAllUserTypeAllocation,
  getRosterOverView,
  getAllScrumTeams,
  getAllCurrentRelease,
  getAllProjectRiskDays,
  getAllProjectMilestone,
  getAllProject,
  getLatestVersion,
  getAllMilestoneRiskDays,
  getAllSprintRiskDays,
  syncUserFromKeycloak,
  getSprintAssemssmentSettings,
  updateSprintAssemssmentSettings,
  getSprintAssessment,
  getSprintAssessmentDetails,
  getAssessmentMaxVersionByProject,
  getVersionUsed,
  getRetroAssessmentStatus,
  getSprintAssemssmentAnalysis,
  getSprintAssemssmentAnalysisSentiment,
  getAssessmentCommentDetails,
  getSentimentDistributions,
  getAssessmentTrendsOverTime,
  getUserManagement,
  clonePermissionsBatch,
  getUserRolesDetail,
  createScrumTeamMember,
  updateScrumTeamMember,
  deleteScrumTeamMember,
  updateUserAllocationBulk,
  getIncidentMatrixStats,
  getIncidentMatrixChart,
  getIncidentOverviewPerformers,
  getIncidentOverviewCategories,
  getBillingBillTos,
  getBillingInvoices,
  getBillingInvoice,
  deleteBillingInvoice,
  uploadBillingInvoice,
  uploadSubmitBillingInvoice,
  getBillingInvoiceImportPreview,
  saveBillingInvoicePreview,
  getSubApplicationList,
  getSubAppRoleAssign,
  getGroups,
  getSubAppRoleAssignAssignedRoles,
  postSubAppRoleAssign,
  getGroupAssignedRoles,
  getGroupAssignedRolesByUserId,
  getMyAccessibleSubApplications,
  postGroupRoleAssign,
  getPlatformDataHubPermission,
  createSubApplication,
  updateSubApplication,
  activeSubApplication,
  getSubApplication,
  getSubApplicationDefault
};
